import { render, staticRenderFns } from "./ModalWithDifferentSizes.vue?vue&type=template&id=059c0925"
import script from "./ModalWithDifferentSizes.vue?vue&type=script&lang=js"
export * from "./ModalWithDifferentSizes.vue?vue&type=script&lang=js"
import style0 from "./ModalWithDifferentSizes.vue?vue&type=style&index=0&id=059c0925&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports